import ClienteService from './../_services/ClienteService'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'
import { clienteModel } from '@/models/cliente'

const state = {
  loading: false,
  loadingStore: false,
  clientes: [],
  currentPage: null,
  urlFirstPage: null,
  urlNextPage: null,
  urlPrevPage: null,
  urlLastPage: null,
  urlPath: null,
  clienteSelecionado: undefined,
  erros: '',
  filter: null,
  loadingStore: false
}

const getters = {
  GET_CLIENTES : (state) => state.clientes,
  GET_URL_PATH : (state) => state.urlPath,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  CLIENTE_SELECTED : (state, { cliente }) => {
    state.clienteSelecionado = Object.assign({}, cliente)
  },

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  MERGE_PESSOA: (state, { pessoa }) => {
    var objOld = Object.assign({}, state.clienteSelecionado)
    objOld.pessoa = pessoa
    state.clienteSelecionado = Object.assign({}, objOld)
  },

  SET_CLIENTES : (state, { clientes }) => {
    state.clientes = JSON.parse(JSON.stringify(clientes))
    state.urlFirstPage = clientes.first_page_url
    state.urlPrevPage = clientes.prev_page_url
    state.urlPrevPage = clientes.prev_page_url
    state.urlLastPage = clientes.last_page_url
    state.urlPath = clientes.path
    state.currentPage = clientes.current_page
  },

  SET_FILTER: (state, filter) => {
    state.filter = filter
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.clienteSelecionado = undefined,

}

const actions = {

  GET_CLIENTES : async ({ commit, state }) => {
      commit('SET_CLIENTES', { clientes : []})
      commit('ERASE_ERROS')
      await ClienteService.getClientes(state.filter)
      .then(response => {
        if (response.data.status) {
          commit('SET_CLIENTES', { clientes : response.data.clientes })
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
        reject(error)
      })
  },

  PAGINATE_CLIENTES : async ({ commit }, url) => {
    commit('ERASE_ERROS')
    await ClienteService.getPagination(url)
    .then(response => {
      if (response.data.status) {
        commit('SET_CLIENTES', { clientes : response.data.clientes })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })
  },

  GET_CLIENTE : async ({commit}, id) => {
    commit('ERASE_ERROS')
    await ClienteService.getCliente(id)
    .then(response => {
      if (response.data.status) {
        commit('CLIENTE_SELECTED', { cliente : response.data.cliente })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })

  },

  GET_CPFCNPJ : async ({commit}, cpfcnpj) => {
    commit('ERASE_ERROS')
    if (!cpfcnpj) return
    await ClienteService.getCpfCnpj(cpfcnpj)
    .then(response => {
      if (response.data.status) {
        var data = response.data
        if (data.cliente) {
          commit('CLIENTE_SELECTED', { cliente : response.data.cliente })
        } else if (data.pessoa) {
          commit('MERGE_PESSOA', { pessoa: data.pessoa })
        }
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })
  },

  STORE_CLIENTE : async ({ commit, dispatch }, cliente) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!cliente.id || !(cliente.id > 0)) { 
        var response = await ClienteService.postCliente(cliente)
      } else {
        var response = await ClienteService.putCliente(cliente.id, cliente)
      }

      if (response.data.status) {
        commit('CLIENTE_SELECTED', { cliente : response.data.cliente })

        if (state.urlPrevPage || state.urlNextPage) {
          await dispatch('PAGINATE_CLIENTES', `${state.urlPath}?page=${state.currentPage}`)
        } else {
          await dispatch('GET_CLIENTES')
        }

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_CLIENTE : async ({ commit, dispatch }, cliente) => {
    commit('ERASE_ERROS')
    try {
      var response = await ClienteService.deleteCliente(cliente.id)

      if (response.data.status) {
        await dispatch('GET_CLIENTES')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  CLIENTE_SELECTED : async ({dispatch, commit}, id) => { 
    if (id > 0) { 
      await dispatch('GET_CLIENTE', id)
    } else {
      var obj = new clienteModel.cliente()
      await commit('CLIENTE_SELECTED', { cliente: obj })
    }
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/Cliente/_store/index.js